import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "copyrightBox" }
const _hoisted_2 = { class: "copyrightTitle" }
const _hoisted_3 = { class: "copyrightPrompt" }
const _hoisted_4 = { class: "copyrightBtn" }
const _hoisted_5 = { class: "btnBox" }
const _hoisted_6 = { key: 0 }

import { Close } from "@element-plus/icons-vue";
  import { ref, onMounted } from "vue";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'infoText',
  emits: ["closeThis",'okRun'],
  setup(__props, { emit: __emit }) {

  const showFrom = ref(false);
  const initNum=ref(15)
  const emit = __emit;
  const bacStyle={
      background: '#232425'
  }
  const bacStylerun={
      background: '#17B067'
  }
  
  let setIntervalTime 
  onMounted(()=>{
      initNum.value=15
      setIntervalTime=setInterval(()=>{
          if(initNum.value>0){
              initNum.value--
          }else{
              clearInterval(setIntervalTime)
              setIntervalTime = null
          }
      },1000)
  })
  // 关闭弹窗
  const closeBox = () => {
      if(initNum.value==0){
          emit("okRun");
      }
    
  };
  const closePage=()=>{
    emit("closeThis");
    
  }
  
return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "‌声音克隆服务版权声明（2025版）", -1)),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: _withModifiers(closePage, ["stop"])
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("p", null, "‌ 一、权利合法性声明", -1),
          _createElementVNode("p", null, "‌上传者保证‌：您上传的音频素材（含录音、音轨文件）必须满足以下任一条件：", -1),
          _createElementVNode("p", null, "▶️ 本人独立创作并拥有完整著作权‌", -1),
          _createElementVNode("p", null, "▶️ 已取得著作权人‌书面授权‌（需提供授权文件扫描件与权利人身份证明）", -1),
          _createElementVNode("p", null, "▶️ 使用公共领域或符合《著作权法》第二十四条的法定许可内容‌", -1),
          _createElementVNode("p", null, " ❗️如涉及他人声音克隆，须额外提交被克隆者亲笔签署的《声音使用授权书》及身份证件 ", -1),
          _createElementVNode("br", null, null, -1),
          _createElementVNode("p", null, "‌禁止上传内容‌：", -1),
          _createElementVNode("p", null, "🔞 包含他人隐私声纹（如通话录音、非公开演讲）", -1),
          _createElementVNode("p", null, "🔞 涉及国家机关/公众人物等特殊身份主体的声音", -1),
          _createElementVNode("p", null, "🔞 存在虚假信息、诽谤内容或违反公序良俗的音频‌", -1),
          _createElementVNode("p", null, "二、授权范围与使用限制", -1),
          _createElementVNode("br", null, null, -1),
          _createElementVNode("p", null, "用户授予本平台的权限‌：", -1),
          _createElementVNode("p", null, "🌐 非独占性技术处理权：对音频进行降噪、特征提取等模型训练必要操作", -1),
          _createElementVNode("p", null, "⏳ 模型存储权：生成的声音模型最长保留365天（可手动删除）", -1),
          _createElementVNode("br", null, null, -1),
          _createElementVNode("p", null, "‌用户禁止行为‌：", -1),
          _createElementVNode("p", null, "🚫 将生成模型用于商业演出、广告营销等营利活动（需单独申请商用授权）‌", -1),
          _createElementVNode("p", null, "🚫 伪造他人声音实施诈骗、诽谤等违法行为‌", -1),
          _createElementVNode("p", null, "🚫 对模型进行反向工程或二次分发‌", -1),
          _createElementVNode("br", null, null, -1),
          _createElementVNode("p", null, "三、侵权责任与争议处理", -1),
          _createElementVNode("p", null, "‌用户承担全部责任‌：如因音频素材或生成内容引发侵权投诉，您须：", -1),
          _createElementVNode("p", null, "⚖️ 在48小时内提交‌完整权属证明‌", -1),
          _createElementVNode("p", null, "💸 赔偿平台因此产生的诉讼费、和解金及商誉损失（最低5万元）‌", -1),
          _createElementVNode("br", null, null, -1),
          _createElementVNode("p", null, "‌平台免责声明‌：", -1),
          _createElementVNode("p", null, "🔒 本服务不包含内容合法性审查，仅提供技术中立工具‌", -1),
          _createElementVNode("p", null, "🔒 发现侵权内容有权删除相关数据‌", -1)
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "btnNo",
          onClick: _withModifiers(closeBox, ["stop"]),
          style: _normalizeStyle(initNum.value>0?bacStyle:bacStylerun)
        }, [
          _cache[2] || (_cache[2] = _createTextVNode("已知悉并同意《声音克隆服务版权声明》 ")),
          (initNum.value>0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(initNum.value), 1))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ])
  ]))
}
}

})